import React, { useContext, useEffect, useState } from "react";
import Android12Switch from "../../../components/common/AndroidSwitch";
import {
  AddUpdateServiceJobTask,
  ChangeServiceJobTaskStatus,
  DeleteServiceJobTask,
  GetServiceJobTaskList,
  GetServiceJobTaskModel,
} from "../../../services/Task/TaskApi";
import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";
import { ERROR_MESSAGES } from "../../../components/common/GlobalMassssage";
import NoResultFoundModel from "../../../components/common/NoDataFound";
import ConfirmationModal from "../../../components/common/ConfirmationModal";
import SuccessModal from "../../../components/common/SuccessModal";
import ErrorModal from "../../../components/common/ErrorModal";
import { FaEdit, FaTrash } from "react-icons/fa";
import PaginationComponent from "../../../components/common/PaginationModal";

// Main Modal Component
const AddTaskModal = ({ isOpen, onClose, modelRequestData }) => {
  const [serviceJobTypeList, setJobTaskList] = useState([]);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  const ModuleName = "Predefined";
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  // Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);
  const [TaskTypeListCount, setTaskListCount] = useState(-1);
  const [taskObj, setTaskObj] = useState({
    taskName: "",
    serviceJobTaskKeyID: null,
  });
  const [taskModelRequestData, setTaskModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
  });

  const [TaskCurrentPage, setTaskCurrentPage] = useState(1);
  const [TaskSearch, setTaskSearch] = useState("");

  useEffect(() => {
    setModelAction(modelRequestData.Action === null ? "Add" : "Update"); //Do not change this naming convention
    if (
      modelRequestData.KeyID !== undefined &&
      modelRequestData.KeyID !== null &&
      modelRequestData.Action === "Update"
    ) {
      GetServiceJobTaskModelData(modelRequestData.KeyID);
    }
    setErrorMessage("");
    resetTaskObj(); // Reset taskObj when the modal opens or the modelRequestData changes
    setIsEditing(false); // Reset editing state
  }, [modelRequestData, isOpen]);

  const resetTaskObj = () => {
    setTaskObj({
      taskName: "",
      serviceJobTaskKeyID: null,
    });
    setRequireErrorMessage(false);
  };

  //Get Model - This might not be needed for the current edit functionality
  const GetServiceJobTaskModelData = async (KeyID) => {
    setLoader(true);
    const data = await GetServiceJobTaskModel(
      ModuleName,
      KeyID,
      authDetails.adminKeyID
    );
    if (data.statusCode === 200) {
      setLoader(false);
      const ModalData = data.responseData.data;
      setTaskModelRequestData(ModalData.serviceJobTaskName);
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (modelRequestData?.KeyID && isOpen) {
      GetJobTaskListData(1);
    } else if (!isOpen) {
      setJobTaskList([]); // Clear the task list when the modal is closed
      setTaskListCount(-1);
    }
  }, [modelRequestData?.KeyID, isOpen]);

  useEffect(() => {
    if (isAddUpdateDone) {
      if (modelRequestData?.KeyID) {
        GetJobTaskListData(1);
      }
      setIsAddUpdateDone(false);
      resetTaskObj(); // Reset the input fields after a successful add or update
      setIsEditing(false); // Go back to "ADD" mode
    }
  }, [isAddUpdateDone, modelRequestData?.KeyID]);

  // List Data Function
  const GetJobTaskListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetServiceJobTaskList({
        moduleName: ModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword: null,
        adminKeyID: authDetails.adminKeyID,
        serviceJobKeyID: modelRequestData?.KeyID,
      });

      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data || [];
        setTaskListCount(response.totalCount);
        setJobTaskList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  // Handle Input Change
  const handleChange = (name, value) => {
    setErrorMessage(false);
    setTaskObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Add Task
  const handleAddTask = async () => {
    if (
      taskObj.taskName === "" ||
      taskObj.taskName === undefined ||
      taskObj.taskName === null
    ) {
      setRequireErrorMessage(true);
      return;
    }

    const newTask = {
      adminKeyID: authDetails.adminKeyID,
      serviceJobKeyID: modelRequestData.KeyID,
      serviceJobTaskKeyID: taskObj.serviceJobTaskKeyID,
      serviceJobTaskName: taskObj.taskName,
      ModuleName: ModuleName,
    };
    setLoader(true);
    try {
      const data = await AddUpdateServiceJobTask(newTask);
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  // Handle Update Task
  const handleUpdateTask = async () => {
    if (!taskObj.taskName) {
      setRequireErrorMessage(true);
      return;
    }

    const updatedTask = {
      adminKeyID: authDetails.adminKeyID,
      serviceJobKeyID: modelRequestData.KeyID,
      serviceJobTaskKeyID: taskObj.serviceJobTaskKeyID, // Will have the ID of the task being edited
      serviceJobTaskName: taskObj.taskName,
      ModuleName: ModuleName,
    };
    setLoader(true);
    try {
      const data = await AddUpdateServiceJobTask(updatedTask);
      if (data?.statusCode === 200) {
        setLoader(false);
        setIsAddUpdateDone(true);
      } else {
        setLoader(false);
        const errorMessage = data?.response?.data?.errorMessage;
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setIsEditing(false); // Switch back to "ADD" mode after update
    }
  };

  // Handle Edit Click
  const handleEditClick = (task) => {
    setIsEditing(true);
    setTaskObj({
      taskName: task.serviceJobTaskName,
      serviceJobTaskKeyID: task.serviceJobTaskKeyID,
    });
    setRequireErrorMessage(false); // Clear any previous error messages
  };

  // Handle Task Status Toggle (optional)
  const handleConfirmBtn = async () => {
    setLoader(true);
    if (modelAction === "Delete") {
      try {
        let data = await DeleteServiceJobTask(
          ModuleName,
          taskModelRequestData.KeyID,
          authDetails.adminKeyID
        );
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setConfirmationModal(false);
          setIsErrorOpen(true);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    } else if (modelAction === "Status") {
      try {
        let data = await ChangeServiceJobTaskStatus(
          ModuleName,
          taskModelRequestData.KeyID,
          authDetails.adminKeyID
        );
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setIsErrorOpen(true);
          setConfirmationModal(false);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    }
  };

  const HandlePageChange = async (pageNumber) => {
    setTaskCurrentPage(pageNumber);
    await GetJobTaskListData(pageNumber); // Call your function with the selected page number
  };

  const handleSearchFunction = (searchValue) => {
    setTaskSearch(searchValue);
    GetJobTaskListData(1, searchValue);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
      {/* Background Overlay */}
      <div className="fixed inset-0 bg-black opacity-50"></div>

      {/* Modal Container */}
      <div className="bg-white rounded-lg shadow-2xl z-10 w-full max-w-xl">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4 border-b flex justify-between items-center">
          <h2 className="text-lg font-semibold">
            {modelRequestData?.Name} - {modelRequestData?.JobName}
          </h2>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Input Fields Row */}
          <div className="flex items-end gap-3 mb-4">
            {/* Task Input */}
            <div className="flex flex-col w-full relative">
              <input
                type="text"
                maxLength={150}
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 text-sm"
                placeholder="Enter Task Name"
                name="taskName"
                value={taskObj.taskName}
                onChange={(e) => {
                  let value = e.target.value;
                  // Capitalize the first letter if the input is not empty

                  if (value.length > 0) {
                    value = value.charAt(0).toUpperCase() + value.slice(1);
                  }
                  // Allow only letters at the start, then letters & spaces after the first character

                  if (/^[A-Za-z][A-Za-z\s]*$/.test(value) || value === "") {
                    handleChange("taskName", value);
                  }
                }}
              />
              <div className="h-5">
                {requireErrorMessage &&
                (taskObj.taskName === "" ||
                  taskObj.taskName === undefined ||
                  taskObj.taskName === null) ? (
                  <label className="validation">{ERROR_MESSAGES}</label>
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Add/Update Button */}
            <div className="flex flex-col relative">
              {!isEditing ? (
                <button
                  className="bg-[#E86B1B] text-white text-12 px-4 py-2 rounded-md hover:bg-[#d45a18] transition self-end"
                  onClick={() => handleAddTask()}
                >
                  ADD
                </button>
              ) : (
                <button
                  className="bg-[#E86B1B] text-white text-12 px-4 py-2 rounded-md hover:bg-[#d45a18] transition self-end"
                  onClick={() => handleUpdateTask()}
                >
                  UPDATE
                </button>
              )}
              <div>&nbsp;</div>
            </div>
          </div>

          <div className="relative flex items-center w-full md:w-64">
            <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
            <input
              type="text"
              className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
              placeholder="Search Task"
              value={TaskSearch}
              onChange={(e) => {
                handleSearchFunction(e.target.value);
              }}
            />
          </div>

          {/* Task List Table */}

          <div className="flex-1 max-h-[50vh] overflow-y-auto">
            <table className="w-full border border-gray-300 mt-4 text-sm">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="border border-gray-300 px-3 py-2 text-left">
                    Task
                  </th>

                  <th className="border border-gray-300 px-3 py-2 text-center">
                    Status
                  </th>
                  <th className="border border-gray-300 px-3 py-2 text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {serviceJobTypeList.map((task, index) => (
                  <tr key={index} className="text-gray-700">
                    <td className="border border-gray-300 px-3 py-2">
                      {task.serviceJobTaskName}
                    </td>

                    <td className="border border-gray-300 px-3 py-2 text-center">
                      <div className="flex items-center space-x-4">
                        <span className={`text-12 font-medium w-[35px]`}>
                          {task.status === "Active" ? "Active" : "InActive"}
                        </span>
                        <Android12Switch
                          checked={task.status === "Active"}
                          onClick={() => {
                            setTaskModelRequestData({
                              ...taskModelRequestData,
                              KeyID: task.serviceJobTaskKeyID,
                              status:
                                task.status === "Active"
                                  ? "InActive"
                                  : "Active",
                            });
                            setModelAction("Status");
                            setConfirmationModal(true);
                          }}
                        />
                      </div>
                    </td>
                    <td className="border border-gray-300 px-3 py-2 text-center">
                      <button
                        className="text-[#135EA0] hover:text-[#135EA0] mr-2"
                        onClick={() => handleEditClick(task)}
                      >
                        <FaEdit className="text-12" />
                      </button>
                      <button
                        className="text-gray-400 hover:text-gray-400"
                        onClick={() => {
                          setTaskModelRequestData({
                            ...taskModelRequestData,
                            KeyID: task.serviceJobTaskKeyID,
                            Name: task.serviceJobTaskName,
                            status: null,
                          });
                          setModelAction("Delete");
                          setConfirmationModal(true);
                        }}
                      >
                        <FaTrash className="text-12" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {TaskTypeListCount <= 0 && (
              <NoResultFoundModel totalRecords={TaskTypeListCount} />
            )}
            {errorMessage && (
              <div className="text-center">
                <label className="validation ">{errorMessage}</label>
              </div>
            )}
          </div>
          {TaskTypeListCount > pageSize && (
            <div className="flex justify-end ">
              <PaginationComponent
                totalPages={Math.ceil(TaskTypeListCount / pageSize)}
                currentPage={TaskCurrentPage}
                onPageChange={HandlePageChange}
              />
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-100 px-6 py-3 rounded-b-lg flex justify-end">
          <button
            className="px-5 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500 transition text-12"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        actionType={modelAction}
        onConfirm={() => handleConfirmBtn()}
        modelRequestData={taskModelRequestData}
      />
      <SuccessModal
        isOpen={showSuccessPopupModal}
        onClose={() => setShowSuccessPopupModal(false)}
        modelAction={modelAction}
        actionMessage={
          modelAction === "Status"
            ? "Status has been changed successfully!"
            : taskModelRequestData.Name
        }
      />
      <ErrorModal
        isOpen={isErrorOpen}
        onClose={() => setIsErrorOpen(false)}
        errorMessage={errorMessage}
      />
    </div>
  );
};

export default AddTaskModal;
